import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 589.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,589.000000) scale(0.100000,-0.100000)">


<path d="M4015 3965 c-99 -23 -241 -57 -314 -74 -74 -17 -137 -34 -140 -37 -3
-3 34 -43 83 -88 49 -45 87 -87 85 -94 -2 -6 -69 -78 -149 -159 -80 -81 -269
-276 -420 -432 -513 -531 -502 -520 -559 -548 -70 -35 -165 -37 -227 -5 -48
24 -110 91 -130 138 -20 48 -18 160 5 209 56 121 185 179 315 141 50 -15 68
-28 146 -109 l90 -92 75 75 c41 41 75 79 75 85 0 13 -163 173 -205 201 -16 11
-57 31 -90 45 -52 21 -76 24 -176 24 l-116 0 -85 -42 c-132 -66 -220 -170
-262 -312 -13 -46 -16 -113 -16 -423 l0 -368 -120 0 -120 0 0 720 0 720 593 0
c468 0 603 -3 643 -14 88 -23 171 -75 234 -144 l58 -64 76 78 c42 44 76 84 76
90 0 19 -132 139 -195 176 -70 43 -183 82 -275 97 -41 7 -318 11 -747 11
l-682 0 -3 -522 c-2 -288 -2 -713 0 -945 l3 -423 339 0 340 0 0 228 c0 126 3
231 6 235 3 3 27 -5 53 -18 63 -32 121 -44 207 -45 144 0 256 53 388 186 75
75 538 550 691 709 196 203 329 335 336 335 5 0 50 -41 99 -91 81 -81 90 -88
94 -67 3 13 21 109 41 213 19 105 45 245 58 312 13 68 22 125 19 128 -7 6 14
10 -197 -40z"/>
<path d="M3649 3155 c-46 -47 -85 -89 -87 -94 -1 -5 15 -11 36 -15 125 -20
222 -135 224 -268 3 -209 -218 -351 -403 -258 -24 12 -81 59 -127 103 l-83 82
-75 -79 c-41 -43 -74 -82 -74 -85 0 -10 139 -143 185 -178 146 -110 382 -124
543 -31 194 111 302 353 247 558 -20 75 -71 175 -113 221 -34 38 -161 129
-179 129 -6 0 -48 -38 -94 -85z"/>
<path d="M4390 2981 l0 -261 65 0 65 0 0 69 0 69 94 4 c116 5 179 33 213 94
38 65 27 171 -21 220 -7 6 -32 22 -57 35 -39 21 -60 24 -201 27 l-158 4 0
-261z m297 138 c47 -29 50 -107 6 -136 -14 -10 -55 -18 -99 -21 l-74 -5 0 93
0 93 73 -5 c39 -3 82 -11 94 -19z"/>
<path d="M4940 2980 l0 -260 60 0 60 0 0 105 0 105 120 0 120 0 0 -105 0 -105
60 0 59 0 3 238 c2 130 2 247 0 260 -3 20 -9 22 -63 22 l-59 0 0 -100 0 -100
-100 -1 c-55 -1 -108 -2 -117 -3 -16 -1 -18 11 -21 102 l-3 102 -59 0 -60 0 0
-260z"/>
<path d="M5688 3193 c-11 -27 -63 -141 -114 -254 -52 -114 -94 -210 -94 -213
0 -3 28 -6 63 -6 l62 0 25 53 25 52 117 3 118 3 27 -56 27 -55 68 0 68 0 -29
58 c-16 31 -42 86 -58 122 -17 36 -58 127 -93 203 l-63 137 -64 0 -64 0 -21
-47z m126 -173 c20 -47 36 -89 36 -93 0 -4 -36 -7 -80 -7 l-80 0 19 48 c31 75
62 144 65 140 2 -2 20 -41 40 -88z"/>
<path d="M6137 3234 c-4 -4 -7 -121 -7 -261 l0 -253 65 0 65 0 -2 258 -3 257
-55 3 c-31 2 -59 0 -63 -4z"/>
<path d="M6329 3238 c0 -2 -3 -24 -5 -50 l-5 -47 88 -3 88 -3 3 -207 2 -208
60 0 60 0 2 208 3 207 87 3 c84 3 88 4 84 25 -3 12 -5 34 -5 50 l-1 27 -230 0
c-126 0 -230 -1 -231 -2z"/>
<path d="M6867 3234 c-4 -4 -7 -121 -7 -261 l0 -253 65 0 65 0 0 105 0 105
115 0 115 0 0 -105 0 -105 65 0 65 0 0 260 0 261 -62 -3 -63 -3 -3 -97 -3 -98
-114 0 -114 0 -3 98 -3 97 -55 3 c-31 2 -59 0 -63 -4z"/>
<path d="M7470 2980 l0 -260 195 0 195 0 0 50 0 50 -135 0 -135 0 0 210 0 210
-60 0 -60 0 0 -260z"/>
<path d="M7927 3233 c-4 -3 -7 -120 -7 -260 l0 -253 65 0 65 0 0 260 0 260
-58 0 c-32 0 -62 -3 -65 -7z"/>
<path d="M8170 2980 l0 -260 60 0 59 0 3 153 3 152 22 -25 c11 -14 69 -82 128
-152 l107 -128 54 0 54 0 -2 258 -3 257 -60 0 -60 0 0 -153 c0 -83 -2 -152 -5
-151 -3 0 -45 50 -95 111 -163 201 -160 198 -216 198 l-49 0 0 -260z"/>
<path d="M8777 3233 c-4 -3 -7 -120 -7 -260 l0 -253 65 0 65 0 0 63 c0 58 3
66 33 95 18 18 35 32 38 32 3 0 39 -42 80 -94 l74 -94 68 -4 c38 -1 71 0 73 4
3 4 -43 67 -101 140 -58 73 -105 138 -105 143 1 6 46 57 100 115 55 57 100
108 100 112 0 4 -29 8 -64 8 l-64 0 -81 -84 c-45 -46 -94 -98 -108 -115 -14
-17 -30 -31 -34 -31 -5 0 -9 52 -9 115 l0 115 -58 0 c-32 0 -62 -3 -65 -7z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
